import { FormHelperText } from '@mui/material';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { SalaryInput } from '../SalaryInput';

interface IControlledSalaryDetails {
  name: string;
}

const ControlledSalaryDetails: FC<IControlledSalaryDetails> = ({ name }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const getError = () => {
    let err = null;
    if (errors[name] != undefined) {
      if (errors[name]?.value?.message) {
        if (
          errors[name]?.value.message.indexOf('currentSalary.value must be a `number`') > -1 ||
          errors[name]?.value.message.indexOf('expectedSalary.value must be a `number`') > -1
        ) {
          err = <FormHelperText error>Salary should be in number only</FormHelperText>;
        } else {
          err = <FormHelperText error>Please fill currency, salary and time period</FormHelperText>;
        }
      } else if (errors[name]?.currency) {
        err = <FormHelperText error>Please fill currency</FormHelperText>;
      } else if (errors[name]?.timeSpan) {
        err = <FormHelperText error>Please fill timespan</FormHelperText>;
      }
    }
    return err;
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <SalaryInput addTimeField onInputChange={onChange} initialValue={value} />
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
      {getError()}
    </>
  );
};

export default ControlledSalaryDetails;
